var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.$style.prefix},[_vm._v("power-bi-reports/")]),_c('span',[_vm._v(_vm._s(_vm.roleName))])])}
var staticRenderFns = []

export { render, staticRenderFns }